<template>
    <div class="alternate-form-ticket-amount">
        <div class="alternate-form-ticket-amount__options">
            <button
                v-for="option in options"
                :key="option"
                type="button"
                class="alternate-form-ticket-amount__quantity-button"
                :class="option === value && !showUserInput ? 'selected' : ''"
                @click="updateValue(option)"
            >
                {{ option }}
            </button>

            <div class="alternate-form-ticket-amount__input-switch">
                <input
                    v-show="showUserInput"
                    id="quantity"
                    ref="userInput"
                    v-model="userInput"
                    class="no-outline"
                    type="number"
                    number
                    name="quantity"
                    step="1"
                    min="1"
                    :max="ticketLimit"
                    pattern="\d*"
                    placeholder="aantal"
                    tabindex="12"
                    @input="overrideUserInput()"
                    @blur="checkUserInput()"
                />
                <button
                    v-show="!showUserInput"
                    class="alternate-form-ticket-amount__input-button"
                    type="button"
                    @click="enableUserInput"
                >
                    anders
                </button>
            </div>
        </div>
        <div v-if="showQuantityMessage" class="alternate-form-ticket-amount__quantity-message">
            <small>
                Wauw, jij wil een bijzondere bijdrage doen en extra veel kans maken op die prijzen! Houd nog even vol,
                want je kunt maximaal {{ ticketLimit }} loten per keer kopen.
            </small>
        </div>
    </div>
</template>

<script>
import './alternate-form-ticket-amount.scss';

export default {
    name: 'AlternateFormTicketAmount',
    props: {
        value: {
            type: Number,
        },
        options: {
            type: Array,
            default: function() {
                return [1, 2, 5];
            },
            required: false,
        },
    },
    data() {
        const showUserInput = this.value && !this?.options.includes(this.value);
        const userInput = showUserInput ? this.value : this?.options[1];

        return {
            quantity: undefined,
            userInput,
            showUserInput,
            showQuantityMessage: false,
            ticketLimit: 200,
        };
    },
    watch: {
        userInput(newVal) {
            if (newVal) {
                this.overrideUserInput();
            }
        },
    },
    created() {
        if (!this.value) this.$emit('input', this?.options[1]);
    },
    methods: {
        updateValue(value) {
            this.resetUserInput();
            this.$emit('input', value);
        },
        resetUserInput() {
            this.showUserInput = false;
            this.userInput = '';
        },
        enableUserInput() {
            this.showUserInput = true;
            if (this.showUserInput) {
                this.$nextTick(() => {
                    this.focusUserInput();
                });
            }
        },
        focusUserInput() {
            this.$refs.userInput.focus();
        },
        overrideUserInput() {
            let invalidCharacters = ['e', 'E', '-', '+', ',', '.'].some(i => this.userInput.includes(i));
            if (this.userInput > this.ticketLimit) {
                if (!this.showQuantityMessage) {
                    this.showQuantityMessage = true;

                    setTimeout(() => {
                        this.showQuantityMessage = false;
                    }, 5000);
                }

                this.userInput = this.ticketLimit;
            } else if (invalidCharacters) {
                let userInput = String(this.userInput).replace(/e/g, '');
                userInput = userInput.replace(/-/g, '');

                this.userInput = parseInt(userInput);
            }

            this.$emit('input', parseInt(this.userInput));
        },

        checkUserInput() {
            if (this.userInput === '') {
                this.resetUserInput();
                this.$emit('input', this?.options[1]);
            }
        },

        isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
    },
};
</script>
